module.exports = __webpack_public_path__ + "static/img/CreatePaperSucceed.780f7ee6.png";